module.exports = __webpack_public_path__ + "img/7.4ca41555.png";